export const GLOSSARY_TEST_IDS = {
  header: 'glossary-header',
  termCard: 'glossary-term-card',
  termsList: 'glossary-terms-list',
  termsNav: 'glossary-terms-nav',
} as const
